// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@tailwind base;
@tailwind components;
@tailwind utilities;

@layer base {
  :root {
    --background: 0 0% 100%; /* #ffffff */
    --foreground: 0 0% 0%; /* #000000 */
    --card: 0 0% 100%; /* #ffffff */
    --card-foreground: 0 0% 0%; /* #000000 */
    --popover: 0 0% 100%; /* #ffffff */
    --popover-foreground: 0 0% 0%; /* #000000 */
    --primary: 218 68% 37%; /* #1e4d9f */
    --primary-foreground: 0 0% 100%; /* #ffffff */
    --secondary: 336 77% 54%; /* #e4317a */
    --secondary-foreground: 0 0% 100%; /* #ffffff */
    --tertiary: 186 83% 37%; /* #109faf */
    --tertiary-foreground: 0 0% 94%; /* #f0f0f0 */
    --muted: 210 14% 83%; /* #4a5573 */
    --muted-foreground: 221 13% 29%; /* #404653 */
    --accent: 0 0% 85%; /* #393e4d */
    --accent-foreground: 0 1% 30%; /* #b9c2d1 */
    --destructive: 0 79% 63%; /* #eb5757 */
    --destructive-foreground: 0 0% 100%; /* #ffffff */
    --input: 0 0% 100%; /* #ffffff */
    --input-foreground: 0 0% 0%; /* #000000 */
    --ring: 218 68% 37%; /* #1e4d9f */
    --success: 123 72% 31%; /* #278917 */
    --success-foreground: 0 0% 100%; /* #ffffff */
    --success-hover: 123 80% 30%; /* #0e8a1a */
    --success-secondary: 163 100% 30%; /* #009966 */
    --success-secondary-hover: 161 100% 27%; /* #008a5c */
    --info: 211 100% 45%; /* #0073e6 */
    --info-foreground: 0 0% 100%; /* #ffffff */
    --label: 0 0% 23%; /* #3B3B3B */
    --seldom: 0, 18, 64; /* #001240 */
    --divider: 214 100% 18%; /* #00295e */

    /* Background color */
    --edit-resume-background: 210 80% 96%; /* #EDF5FD */
    --search-bar: 204, 22%, 95%; /* #F1F4F6 */
    --active-nav: 218, 80%, 23%; /*#0C2E6A*/
    --project-nav: 228 81% 18%; /*091855*/

    /* Primary colors palette */
    --primary-50: 210 79% 89%; /* #CBE2F9 */
    --primary-100: 206 73% 96%; /* #ECF5FC */
    --primary-200: 226 73% 96%; /* #F1F4FD */
    --primary-300: 199 100% 88%; /* #C1EAFF */
    --primary-350: 205 60% 84%; /* #BFDBEF */
    --primary-400: 198 73% 63%; /* #5CBDE6 */
    --primary-450: 218 84% 88%; /*#C7DAFA*/
    --primary-500: 198 73% 58%; /* #45B4E2 */
    --primary-600: 198 73% 52%; /* #2BA9DE */
    --primary-650: 219 77% 28%; /*#10367D*/
    --primary-700: 201 100% 45%; /* #0095E4 */
    --primary-750: 228 80% 21%; /* #0B1D62 */
    --primary-800: 204 99% 36%; /* #016FB9 */
    --primary-850: 202 93% 45%; /* #0890DD */
    --primary-900: 214 100% 18%; /* #00295e */
    --primary-950: 229 81% 18%; /* #091855 */

    /* Secondary colors palette */
    --secondary-100: 336 74% 47%; /* #d11f68 */

    /* Frost colors palette */
    --frost-50: 220 14% 96%; /* #f3f4f6 */
    --frost-100: 200 18% 93%; /* #ebeff1 */
    --frost-150: 200 17% 93%; /* #EAEEF0 */
    --frost-200: 213 25% 95%; /* #edf2f8 */
    --frost-250: 0 0% 85%; /* #d9d9d9 */
    --frost-300: 225 5% 71%; /* #b3b5ba */
    --frost-400: 0 0% 70%; /* #b2b2b2 */
    --frost-500: 0 0% 67%; /* #ababab */
    --frost-600: 0 0% 46%; /* #757575 */
    --frost-650: 212 13% 61%; /* #8f98a8 */
    --frost-700: 214 13% 41%; /* #5c6677 */
    --frost-750: 213 15% 38%; /* #535d6f */
    --frost-800: 213 16% 36%; /* #4d586b */
    --frost-900: 221 13% 29%; /* #404653 */
    --frost-950: 217 14% 25%; /* #374151 */

    /* Border color palette */
    --border-200: 240 36% 95%; /* #ECECF6 */
    --border-250: 216 26% 91%; /* #e2e7ef */
    --border-270: 211 20% 86%; /* #d2d8e3 */
    --border-300: 200 18% 93%; /* #EBEFF1 */
    --border-350: 220 18% 88%; /* #d9dde7 */
    --border-400: 210 22% 84%; /* #cbd5e1 */
    --border-450: 213 18% 85%; /* #cfd5e1 */
    --border-500: 27 10% 82%; /* #d6d1cd */
    --border-600: 0 0 85%; /* #d9d9d9 */

    /* Label status background color */
    --label-100: 48 100% 71%; /* #FFE16B */
    --label-200: 357 95% 93%; /* #FEDBDD */
    --label-300: 38 79% 81%; /* #F5D9A8 */
    --label-350: 210 79% 89%; /* #CBE2F9 */
    --label-400: 156 64% 90%; /* #D6F6E9 */
    --label-450: 201 100% 80%; /* #99DCFF */
    --label-500: 201 100% 64%; /* #46BFFF */
    --label-550: 222 61% 53%; /*#3E69D0*/
    --label-600: 0 0% 25%; /* #404040 */
    --label-650: 35 100% 84%; /* #FFDDAD */
    --label-700: 33 86% 46%; /* #DC8211 */

    --label-completed: 149 100% 39%; /* #00C860 */
    --label-archived: 307 25% 66%; /* #BE94B9 */
    --label-archived-text: 300 61% 24%; /* #611761 */

    /* Label status info color */
    --info-100: 330 99% 37%; /* #BA015E */
    --info-200: 26 100% 25%; /* #813800 */
    --info-300: 48 71% 23%; /* #635211 */
    --info-700: 204 78% 29%; /* #105584 */
    --info-800: 152 100% 26%; /* #008747 */

    /* Ocean color palette */
    --ocean-50: 214 100% 98%; /* #f5f9ff */
    --ocean-200: 200 33% 68%; /* #94B7C9 */
    --ocean-500: 210 62% 44%; /* #2b74b6 */
    --ocean-550: 210 62% 37%; /* #23649d */
    --ocean-600: 205 72% 40%; /* #1D71AF */
    --ocean-650: 210 34% 32%; /* #36506c */
    --ocean-700: 208 98% 26%; /* #014783 */

    /* Project palette colors */
    --grass: 98 64% 46%; /* #61bf2a */
    --tangerine: 33 85% 53%; /* #ed9121 */
    --ocean: 201 100% 45%; /* #0095e4 */
    --crimson: 336 77% 54%; /* #e4317a */
    --chartreuse: 58 97% 36%; /* #b7b103 */
    --midnight: 205 100% 28%; /* #00548f */
    --amethyst: 265 58% 62%; /* #9466d6 */
    --steel: 229 19% 59%; /* #838AAA */

    /* Employee relationship role colors */
    --golden: 43 98% 66%; /* #FDCD56 */
    --mint: 160 50% 60%; /* #67CCAB */
    --lavender: 248 29% 53%; /* #6C63A9 */
    --coral: 5 71% 66%; /* #E6766B */
    --slate-blue: 221 37% 49%; /* #4F6CAC */
    --cornflower: 232 70% 66%; /* #6B7CE5 */
  }
  * {
    @apply border-border;
  }
  html {
    @apply scroll-smooth;
    @apply scroll-pt-header-nav;
  }

  /*
  * Override CopilotKit inline styles – must use !important
  */
  body {
    @apply bg-background text-foreground !static !overflow-auto !h-auto;
  }

  /* Scroll lock override for data-scroll-locked attribute */
  html body[data-scroll-locked] {
    overflow: visible !important;
    margin-right: 0 !important;
  }

  /* Styles for list bullet points */
  li::marker {
    @apply text-slate-800/80;
  }

  #employee-info {
    li::marker {
      @apply text-frost-900;
    }

    code {
      @apply bg-frost-400;
    }
  }

  [id='project-description'] li::marker {
    @apply text-white;
  }

  [id='employee-training-content'] li {
    @apply list-disc list-inside;
  }
}

@layer utilities {
  .flex-center {
    @apply flex items-center justify-center;
  }

  .flex-start {
    @apply flex items-center justify-start;
  }

  .centered-container {
    @apply flex items-center flex-col py-14 px-6 lg:py-0 lg:h-screen;
  }

  .user-content-spacing {
    @apply py-4 px-4 sm:px-8 sm:py-15.25 lg:py-6.5 lg:px-6.5;
  }

  .break-word {
    word-break: break-word;
  }

  /* Custom leading */
  .custom-leading p,
  .custom-leading li,
  .custom-leading li::marker,
  .custom-leading ul,
  .custom-leading ol,
  .custom-leading span,
  .custom-leading a,
  .custom-leading div,
  .custom-leading blockquote {
    @apply text-white leading-2xs w-fit;
  }

  /* Custom scrollbar */
  ::-webkit-scrollbar {
    @apply w-3 h-3 bg-transparent;
  }

  ::-webkit-scrollbar:hover {
    @apply w-3 h-3;
    background-color: rgba(0, 0, 0, 0.06);
  }

  .tiny-scrollbar::-webkit-scrollbar {
    @apply w-[5px] sm:w-1.5;
  }

  .tiny-scrollbar::-webkit-scrollbar:hover {
    @apply w-[5px] sm:w-1.5;
  }

  .small-scrollbar::-webkit-scrollbar {
    @apply w-2 h-2;
  }

  .small-scrollbar::-webkit-scrollbar:hover {
    @apply w-2 h-2;
  }

  /* Overlay scrollbar - scrollbar does not take up space */
  .overlay-scrollbar {
    overflow-y: overlay; /* Works in Chromium browsers */
  }

  /* Fallback for browsers that don't support overlay */
  @supports not (overflow-y: overlay) {
    .overlay-scrollbar {
      overflow-y: auto;
      scrollbar-gutter: stable;
    }
  }

  ::-webkit-scrollbar-thumb {
    @apply rounded bg-black/25 min-h-10;
  }

  ::-webkit-scrollbar-thumb:active {
    @apply bg-black/40;
  }

  /* Icon */
  .fill-icon {
    @apply fill-gray-700 dark:fill-gray-100;
  }

  .stroke-icon {
    @apply stroke-gray-700 dark:stroke-gray-100;
  }

  .select-icon-button {
    @apply size-4 flex-center transition-colors cursor-pointer;
  }

  .select-icon-button:disabled {
    @apply cursor-not-allowed;
  }

  .clear-icon-button {
    @apply size-full text-frost-500 hover:text-primary-500;
  }

  .select-icon-button:disabled .clear-icon-button {
    @apply text-frost-300 hover:text-frost-300;
  }

  /* Override browser autocomplete background */
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-text-fill-color: hsl(var(--slate-800)) !important;
    transition: background-color 5000s ease-in-out 0s;
  }

  .dark input:-webkit-autofill,
  .dark input:-webkit-autofill:hover,
  .dark input:-webkit-autofill:focus,
  .dark input:-webkit-autofill:active {
    @apply bg-background;
    -webkit-text-fill-color: white !important;
    box-shadow: inset 0 0 20px 20px var(--background);
    caret-color: white;
  }

  .aspect-a4 {
    @apply aspect-[1/1.414];
  }

  /* Hide scrollbar for Chrome, Safari and Opera */
  .no-scrollbar::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  .no-scrollbar {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
}

@layer components {
  .cl-base-button {
    @apply flex-center rounded-sm font-medium transition-colors;
    @apply text-2xs md:text-xs xl:text-md;
    @apply bg-primary text-primary-foreground hover:bg-destructive;
    @apply [&_svg]:pointer-events-none [&_svg]:shrink-0;
    @apply focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring;
    @apply disabled:pointer-events-none disabled:opacity-50;
    @apply data-[variant=solid]:data-[color=primary]:shadow-none;
  }

  .cl-base-text {
    @apply text-3xs xl:text-xs;
  }

  .cl-base-form {
    @apply w-full max-w-form h-full mx-auto overflow-hidden;

    .cl-cardBox {
      @apply w-full shadow-none border-none overflow-visible;
    }

    .cl-card {
      @apply w-full p-0 rounded-none shadow-none dark:bg-background;
    }

    .cl-form {
      @apply order-1 dark:bg-background;
    }

    .cl-dividerRow {
      @apply order-2 hidden;
    }

    .cl-socialButtonsRoot {
      @apply order-3 hidden;
    }

    .cl-footer {
      @apply hidden;
    }

    .cl-headerTitle {
      @apply text-2xl md:text-3xl xl:text-[28px] dark:text-foreground font-normal;
    }

    .cl-headerSubtitle,
    .cl-identityPreviewText {
      @apply text-3xs text-slate-500 font-normal;
      @apply dark:text-white/70;
    }

    .cl-formButtonPrimary,
    .cl-alternativeMethodsBlockButton {
      @apply cl-base-button;
    }

    .cl-formResendCodeLink {
      @apply cl-base-text font-normal text-info disabled:opacity-55 dark:disabled:opacity-65;
    }

    .cl-identityPreviewEditButton {
      @apply hidden;
    }

    .cl-otpCodeField {
      .cl-otpCodeFieldInput {
        @apply size-10 sm:size-14 md:size-[70px] max-h-none;
        @apply text-3xs md:text-xs dark:text-foreground ring-1 ring-slate-200 rounded-md;
        @apply dark:hover:ring-1 dark:hover:ring-white dark:focus:ring-1 dark:focus:ring-white dark:active:ring-1 dark:active:ring-white;
        @apply focus:shadow-none focus:ring-slate-800 focus:bg-white dark:focus:bg-background;

        /* Focus styles */
        @apply data-[feedback=error]:focus-within:shadow-none;
        @apply data-[feedback=error]:focus-within:ring-destructive;
        @apply data-[feedback=success]:focus-within:shadow-none;
        @apply data-[feedback=success]:focus-within:ring-success;

        /* Hover styles */
        @apply data-[feedback=error]:hover:shadow-none;
        @apply data-[feedback=error]:hover:ring-destructive;
        @apply data-[feedback=success]:hover:shadow-none;
        @apply data-[feedback=success]:hover:ring-success;

        /* Active styles */
        @apply data-[feedback=error]:active:shadow-none;
        @apply data-[feedback=error]:active:ring-destructive;
        @apply data-[feedback=success]:active:shadow-none;
        @apply data-[feedback=success]:active:ring-success;
      }

      .cl-otpCodeFieldErrorText {
        @apply [&_svg]:text-destructive cl-base-text text-destructive;
      }
    }

    .cl-alert {
      @apply [&_svg]:text-destructive;

      .cl-alertText {
        @apply text-destructive;
      }
    }

    .cl-formFieldLabel {
      @apply dark:text-foreground;
    }

    .cl-formFieldInput {
      @apply ring-1 ring-border hover:ring-slate-300 focus:ring-slate-300 active:ring-slate-300;
      @apply dark:bg-background dark:focus:bg-background dark:text-foreground;
      @apply dark:ring-white/50 dark:ring-1 dark:placeholder:text-white/55;
      @apply dark:hover:ring-1 dark:hover:ring-white dark:focus:ring-1 dark:focus:ring-white dark:active:ring-1 dark:active:ring-white;
      @apply data-[feedback=success]:shadow-none data-[feedback=success]:ring-success/50;
      @apply data-[feedback=error]:shadow-none data-[feedback=error]:ring-destructive/50;

      /* Focus styles */
      @apply data-[feedback=error]:focus-within:shadow-none;
      @apply data-[feedback=error]:focus-within:ring-destructive;
      @apply data-[feedback=success]:focus-within:shadow-none;
      @apply data-[feedback=success]:focus-within:ring-success;

      /* Hover styles */
      @apply data-[feedback=error]:hover:shadow-none;
      @apply data-[feedback=error]:hover:ring-destructive;
      @apply data-[feedback=success]:hover:shadow-none;
      @apply data-[feedback=success]:hover:ring-success;

      /* Active styles */
      @apply data-[feedback=error]:active:shadow-none;
      @apply data-[feedback=error]:active:ring-destructive;
      @apply data-[feedback=success]:active:shadow-none;
      @apply data-[feedback=success]:active:ring-success;
    }

    .cl-formFieldInputShowPasswordButton {
      @apply fill-gray-700 dark:fill-gray-100 dark:stroke-gray-100 group-hover:dark:fill-gray-700 group-hover:dark:stroke-slate-800;
    }
  }

  /* Forgot password */
  .cl-base-form .cl-card.cl-signIn-forgotPasswordMethods {
    @apply gap-14;

    .cl-formResendCodeLink {
      @apply bg-transparent hover:bg-transparent text-xs mt-13.75;
    }

    .cl-alternativeMethodsBlockButton {
      @apply py-3.75;
    }

    .cl-backLink {
      @apply hidden;
    }
  }

  .cl-base-form:has(
    .cl-headerTitle[data-localization-key='signIn.forgotPasswordAlternativeMethods.title']
  ) {
    @apply h-full flex-center;
  }

  /* Reset new password */
  .cl-base-form.cl-signIn-root .cl-cardBox.cl-signIn-resetPassword {
    @apply h-full flex-center;
  }

  .cl-base-form.cl-signIn-root .cl-card.cl-signIn-resetPassword {
    @apply gap-12;

    .cl-form {
      @apply -order-none gap-0;
    }

    .cl-headerSubtitle {
      @apply mt-3;
    }

    .cl-formResendCodeLink {
      @apply mt-13.75 text-xs;
    }

    .cl-formButtonPrimary {
      @apply py-3.75;
    }

    .cl-buttonArrowIcon {
      @apply hidden;
    }
  }

  /* Set new password form */
  .cl-base-form.cl-signIn-root {
    &:has(h1[data-localization-key='signIn.resetPassword.title']) {
      @apply flex-center;
    }

    &:not(
        :has(label[data-localization-key='formFieldLabel__emailAddress'])
      ):has(label[data-localization-key='formFieldLabel__password']) {
      @apply lg:pt-36;
    }

    .cl-card {
      @apply gap-14 lg:gap-24;
    }

    .cl-formFieldRow__signOutOfOtherSessions {
      @apply hidden;
    }

    .cl-footerAction__alternativeMethods {
      @apply hidden;
    }
  }

  /* SignUp */
  .cl-base-form {
    .cl-signUp-start .cl-header {
      @apply hidden;
    }

    .cl-formFieldLabel {
      @apply cl-base-text font-normal text-label mb-1;
    }

    .cl-formFieldInput {
      @apply cl-base-text;
      @apply min-h-14 rounded-md;
      @apply focus:shadow-none focus:ring-slate-800 focus:bg-white;
      @apply placeholder:text-slate-500 placeholder:opacity-50;
    }

    .cl-formFieldInfoText {
      @apply text-slate-500;
    }

    .cl-formFieldErrorText {
      @apply mt-3 text-destructive [&_svg]:text-destructive;
    }

    .cl-formFieldSuccessText {
      @apply cl-base-text text-success [&_svg]:text-success;
    }

    .cl-form {
      @apply gap-12;
    }

    .cl-formFieldInputShowPasswordButton {
      @apply shadow-none h-full bg-transparent;

      .cl-formFieldInputShowPasswordIcon {
        @apply w-6 h-6;
      }
    }

    .cl-formButtonPrimary {
      @apply rounded-md py-[14px] [&_svg]:hidden;
    }
  }

  /* Verify email */
  .cl-base-form .cl-signUp-emailCode {
    @apply gap-8 h-full;

    .cl-card {
      @apply flex-center h-full;
    }

    .cl-headerTitle {
      @apply mb-3;
    }

    .cl-main {
      @apply gap-7 mt-4;
    }

    .cl-form {
      @apply order-none gap-11;
    }
  }

  /* LogIn */
  .cl-base-form {
    .cl-signIn-start {
      .cl-card {
        @apply gap-12;
      }

      .cl-header {
        @apply hidden;
      }

      .cl-form {
        @apply gap-14 lg:gap-[65px];
      }
    }

    .cl-signIn-password {
      .cl-header {
        @apply hidden;
      }

      .cl-card {
        @apply gap-12;
      }

      .cl-form {
        @apply gap-14 lg:gap-[65px];
      }
    }

    .cl-formFieldLabelRow {
      @apply contents;
    }

    .cl-formFieldAction {
      @apply absolute right-0 bottom-[-30px];
      @apply cl-base-text font-normal text-info;
    }

    .cl-formFieldInputGroup {
      @apply order-none;
    }

    .cl-formField {
      @apply relative px-1;
    }

    .cl-formFieldErrorText {
      @apply cl-base-text text-destructive;
    }

    .cl-signIn-emailCode {
      .cl-card {
        @apply gap-12;
      }

      .cl-main {
        @apply gap-7;
      }

      .cl-form {
        @apply order-none gap-11;
      }
    }
  }
}

.text-shadow-md {
  text-shadow:
    0px 1px 1px rgb(0 0 0 / 0.1),
    0px 1px 2px rgb(0 0 0 / 0.1),
    0px 2px 4px rgb(0 0 0 / 0.1);
}

.react-pdf__message--loading,
.react-pdf__Document {
  height: 100%;
}

.react-pdf__Page {
  height: 100%;
}

.scale-up-center {
  -webkit-animation: scale-up-center 0.2s cubic-bezier(0.39, 0.575, 0.565, 1)
    both;
  animation: scale-up-center 0.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

@keyframes flash-error {
  0%,
  100% {
    background-color: hsl(var(--destructive));
    color: hsl(var(--destructive-foreground));
  }
  50% {
    background-color: transparent;
    color: hsl(var(--slate-800));
  }
}

.animate-flash-error {
  animation: flash-error;
}

@-webkit-keyframes scale-up-center {
  0% {
    -webkit-transform: scale(0.5);
    transform: scale(0.5);
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
@keyframes scale-up-center {
  0% {
    -webkit-transform: scale(0.5);
    transform: scale(0.5);
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/tailwind-config/styles/index.css"],"names":[],"mappings":"AAAA,cAAc;AACd,oBAAoB;AACpB,mBAAmB;;AAEnB;EACE;IACE,uBAAuB,EAAE,YAAY;IACrC,qBAAqB,EAAE,YAAY;IACnC,iBAAiB,EAAE,YAAY;IAC/B,0BAA0B,EAAE,YAAY;IACxC,oBAAoB,EAAE,YAAY;IAClC,6BAA6B,EAAE,YAAY;IAC3C,sBAAsB,EAAE,YAAY;IACpC,+BAA+B,EAAE,YAAY;IAC7C,wBAAwB,EAAE,YAAY;IACtC,iCAAiC,EAAE,YAAY;IAC/C,uBAAuB,EAAE,YAAY;IACrC,+BAA+B,EAAE,YAAY;IAC7C,oBAAoB,EAAE,YAAY;IAClC,+BAA+B,EAAE,YAAY;IAC7C,kBAAkB,EAAE,YAAY;IAChC,6BAA6B,EAAE,YAAY;IAC3C,wBAAwB,EAAE,YAAY;IACtC,mCAAmC,EAAE,YAAY;IACjD,kBAAkB,EAAE,YAAY;IAChC,2BAA2B,EAAE,YAAY;IACzC,mBAAmB,EAAE,YAAY;IACjC,sBAAsB,EAAE,YAAY;IACpC,+BAA+B,EAAE,YAAY;IAC7C,4BAA4B,EAAE,YAAY;IAC1C,iCAAiC,EAAE,YAAY;IAC/C,uCAAuC,EAAE,YAAY;IACrD,oBAAoB,EAAE,YAAY;IAClC,4BAA4B,EAAE,YAAY;IAC1C,iBAAiB,EAAE,YAAY;IAC/B,mBAAmB,EAAE,YAAY;IACjC,uBAAuB,EAAE,YAAY;;IAErC,qBAAqB;IACrB,qCAAqC,EAAE,YAAY;IACnD,2BAA2B,EAAE,YAAY;IACzC,2BAA2B,EAAE,UAAU;IACvC,0BAA0B,EAAE,SAAS;;IAErC,2BAA2B;IAC3B,yBAAyB,EAAE,YAAY;IACvC,0BAA0B,EAAE,YAAY;IACxC,0BAA0B,EAAE,YAAY;IACxC,2BAA2B,EAAE,YAAY;IACzC,0BAA0B,EAAE,YAAY;IACxC,0BAA0B,EAAE,YAAY;IACxC,0BAA0B,EAAE,UAAU;IACtC,0BAA0B,EAAE,YAAY;IACxC,0BAA0B,EAAE,YAAY;IACxC,0BAA0B,EAAE,UAAU;IACtC,2BAA2B,EAAE,YAAY;IACzC,0BAA0B,EAAE,YAAY;IACxC,0BAA0B,EAAE,YAAY;IACxC,0BAA0B,EAAE,YAAY;IACxC,2BAA2B,EAAE,YAAY;IACzC,0BAA0B,EAAE,YAAY;;IAExC,6BAA6B;IAC7B,4BAA4B,EAAE,YAAY;;IAE1C,yBAAyB;IACzB,uBAAuB,EAAE,YAAY;IACrC,wBAAwB,EAAE,YAAY;IACtC,wBAAwB,EAAE,YAAY;IACtC,wBAAwB,EAAE,YAAY;IACtC,qBAAqB,EAAE,YAAY;IACnC,uBAAuB,EAAE,YAAY;IACrC,qBAAqB,EAAE,YAAY;IACnC,qBAAqB,EAAE,YAAY;IACnC,qBAAqB,EAAE,YAAY;IACnC,wBAAwB,EAAE,YAAY;IACtC,wBAAwB,EAAE,YAAY;IACtC,wBAAwB,EAAE,YAAY;IACtC,wBAAwB,EAAE,YAAY;IACtC,wBAAwB,EAAE,YAAY;IACtC,wBAAwB,EAAE,YAAY;;IAEtC,yBAAyB;IACzB,yBAAyB,EAAE,YAAY;IACvC,yBAAyB,EAAE,YAAY;IACvC,yBAAyB,EAAE,YAAY;IACvC,yBAAyB,EAAE,YAAY;IACvC,yBAAyB,EAAE,YAAY;IACvC,yBAAyB,EAAE,YAAY;IACvC,yBAAyB,EAAE,YAAY;IACvC,wBAAwB,EAAE,YAAY;IACtC,qBAAqB,EAAE,YAAY;;IAEnC,kCAAkC;IAClC,wBAAwB,EAAE,YAAY;IACtC,wBAAwB,EAAE,YAAY;IACtC,uBAAuB,EAAE,YAAY;IACrC,wBAAwB,EAAE,YAAY;IACtC,wBAAwB,EAAE,YAAY;IACtC,yBAAyB,EAAE,YAAY;IACvC,yBAAyB,EAAE,YAAY;IACvC,wBAAwB,EAAE,UAAU;IACpC,qBAAqB,EAAE,YAAY;IACnC,wBAAwB,EAAE,YAAY;IACtC,uBAAuB,EAAE,YAAY;;IAErC,+BAA+B,EAAE,YAAY;IAC7C,6BAA6B,EAAE,YAAY;IAC3C,kCAAkC,EAAE,YAAY;;IAEhD,4BAA4B;IAC5B,uBAAuB,EAAE,YAAY;IACrC,uBAAuB,EAAE,YAAY;IACrC,sBAAsB,EAAE,YAAY;IACpC,uBAAuB,EAAE,YAAY;IACrC,wBAAwB,EAAE,YAAY;;IAEtC,wBAAwB;IACxB,wBAAwB,EAAE,YAAY;IACtC,wBAAwB,EAAE,YAAY;IACtC,wBAAwB,EAAE,YAAY;IACtC,wBAAwB,EAAE,YAAY;IACtC,wBAAwB,EAAE,YAAY;IACtC,wBAAwB,EAAE,YAAY;IACtC,wBAAwB,EAAE,YAAY;;IAEtC,2BAA2B;IAC3B,mBAAmB,EAAE,YAAY;IACjC,uBAAuB,EAAE,YAAY;IACrC,qBAAqB,EAAE,YAAY;IACnC,sBAAsB,EAAE,YAAY;IACpC,wBAAwB,EAAE,YAAY;IACtC,wBAAwB,EAAE,YAAY;IACtC,uBAAuB,EAAE,YAAY;IACrC,oBAAoB,EAAE,YAAY;;IAElC,sCAAsC;IACtC,oBAAoB,EAAE,YAAY;IAClC,mBAAmB,EAAE,YAAY;IACjC,uBAAuB,EAAE,YAAY;IACrC,kBAAkB,EAAE,YAAY;IAChC,yBAAyB,EAAE,YAAY;IACvC,yBAAyB,EAAE,YAAY;EACzC;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;IACpB,2BAA2B;EAC7B;;EAEA;;GAEC;EACD;IACE,mEAAmE;EACrE;;EAEA,0DAA0D;EAC1D;IACE,4BAA4B;IAC5B,0BAA0B;EAC5B;;EAEA,kCAAkC;EAClC;IACE,wBAAwB;EAC1B;;EAEA;IACE;MACE,qBAAqB;IACvB;;IAEA;MACE,mBAAmB;IACrB;EACF;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,uCAAuC;EACzC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,gEAAgE;EAClE;;EAEA;IACE,wDAAwD;EAC1D;;EAEA;IACE,sBAAsB;EACxB;;EAEA,mBAAmB;EACnB;;;;;;;;;IASE,mCAAmC;EACrC;;EAEA,qBAAqB;EACrB;IACE,6BAA6B;EAC/B;;EAEA;IACE,cAAc;IACd,qCAAqC;EACvC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA,yDAAyD;EACzD;IACE,mBAAmB,EAAE,+BAA+B;EACtD;;EAEA,qDAAqD;EACrD;IACE;MACE,gBAAgB;MAChB,wBAAwB;IAC1B;EACF;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,kBAAkB;EACpB;;EAEA,SAAS;EACT;IACE,uCAAuC;EACzC;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,0DAA0D;EAC5D;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sDAAsD;EACxD;;EAEA;IACE,0CAA0C;EAC5C;;EAEA,6CAA6C;EAC7C;;;;IAIE,yDAAyD;IACzD,iDAAiD;EACnD;;EAEA;;;;IAIE,oBAAoB;IACpB,yCAAyC;IACzC,iDAAiD;IACjD,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA,gDAAgD;EAChD;IACE,aAAa;EACf;;EAEA,4CAA4C;EAC5C;IACE,wBAAwB,EAAE,gBAAgB;IAC1C,qBAAqB,EAAE,YAAY;EACrC;AACF;;AAEA;EACE;IACE,2DAA2D;IAC3D,qCAAqC;IACrC,8DAA8D;IAC9D,mDAAmD;IACnD,8EAA8E;IAC9E,uDAAuD;IACvD,4DAA4D;EAC9D;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,uDAAuD;;IAEvD;MACE,sDAAsD;IACxD;;IAEA;MACE,6DAA6D;IAC/D;;IAEA;MACE,iCAAiC;IACnC;;IAEA;MACE,qBAAqB;IACvB;;IAEA;MACE,qBAAqB;IACvB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,2EAA2E;IAC7E;;IAEA;;MAEE,0CAA0C;MAC1C,yBAAyB;IAC3B;;IAEA;;MAEE,qBAAqB;IACvB;;IAEA;MACE,sFAAsF;IACxF;;IAEA;MACE,aAAa;IACf;;IAEA;MACE;QACE,mDAAmD;QACnD,gFAAgF;QAChF,gIAAgI;QAChI,qFAAqF;;QAErF,iBAAiB;QACjB,qDAAqD;QACrD,0DAA0D;QAC1D,uDAAuD;QACvD,wDAAwD;;QAExD,iBAAiB;QACjB,8CAA8C;QAC9C,mDAAmD;QACnD,gDAAgD;QAChD,iDAAiD;;QAEjD,kBAAkB;QAClB,+CAA+C;QAC/C,oDAAoD;QACpD,iDAAiD;QACjD,kDAAkD;MACpD;;MAEA;QACE,6DAA6D;MAC/D;IACF;;IAEA;MACE,+BAA+B;;MAE/B;QACE,uBAAuB;MACzB;IACF;;IAEA;MACE,2BAA2B;IAC7B;;IAEA;MACE,yFAAyF;MACzF,uEAAuE;MACvE,oEAAoE;MACpE,gIAAgI;MAChI,kFAAkF;MAClF,kFAAkF;;MAElF,iBAAiB;MACjB,qDAAqD;MACrD,0DAA0D;MAC1D,uDAAuD;MACvD,wDAAwD;;MAExD,iBAAiB;MACjB,8CAA8C;MAC9C,mDAAmD;MACnD,gDAAgD;MAChD,iDAAiD;;MAEjD,kBAAkB;MAClB,+CAA+C;MAC/C,oDAAoD;MACpD,iDAAiD;MACjD,kDAAkD;IACpD;;IAEA;MACE,6HAA6H;IAC/H;EACF;;EAEA,oBAAoB;EACpB;IACE,aAAa;;IAEb;MACE,2DAA2D;IAC7D;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,aAAa;IACf;EACF;;EAEA;;;IAGE,yBAAyB;EAC3B;;EAEA,uBAAuB;EACvB;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;;IAEb;MACE,wBAAwB;IAC1B;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,uBAAuB;IACzB;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,aAAa;IACf;EACF;;EAEA,0BAA0B;EAC1B;IACE;MACE,kBAAkB;IACpB;;IAEA;;;MAGE,eAAe;IACjB;;IAEA;MACE,uBAAuB;IACzB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,aAAa;IACf;EACF;;EAEA,WAAW;EACX;IACE;MACE,aAAa;IACf;;IAEA;MACE,+CAA+C;IACjD;;IAEA;MACE,mBAAmB;MACnB,0BAA0B;MAC1B,4DAA4D;MAC5D,wDAAwD;IAC1D;;IAEA;MACE,qBAAqB;IACvB;;IAEA;MACE,qDAAqD;IACvD;;IAEA;MACE,qDAAqD;IACvD;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,wCAAwC;;MAExC;QACE,cAAc;MAChB;IACF;;IAEA;MACE,0CAA0C;IAC5C;EACF;;EAEA,iBAAiB;EACjB;IACE,mBAAmB;;IAEnB;MACE,yBAAyB;IAC3B;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,wBAAwB;IAC1B;EACF;;EAEA,UAAU;EACV;IACE;MACE;QACE,aAAa;MACf;;MAEA;QACE,aAAa;MACf;;MAEA;QACE,2BAA2B;MAC7B;IACF;;IAEA;MACE;QACE,aAAa;MACf;;MAEA;QACE,aAAa;MACf;;MAEA;QACE,2BAA2B;MAC7B;IACF;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,sCAAsC;MACtC,yCAAyC;IAC3C;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,oBAAoB;IACtB;;IAEA;MACE,oCAAoC;IACtC;;IAEA;MACE;QACE,aAAa;MACf;;MAEA;QACE,YAAY;MACd;;MAEA;QACE,wBAAwB;MAC1B;IACF;EACF;AACF;;AAEA;EACE;;;gCAG8B;AAChC;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;QACM;EACN,wEAAwE;AAC1E;;AAEA;EACE;;IAEE,yCAAyC;IACzC,yCAAyC;EAC3C;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,6BAA6B;IAC7B,qBAAqB;EACvB;EACA;IACE,2BAA2B;IAC3B,mBAAmB;EACrB;AACF;AACA;EACE;IACE,6BAA6B;IAC7B,qBAAqB;EACvB;EACA;IACE,2BAA2B;IAC3B,mBAAmB;EACrB;AACF","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer base {\n  :root {\n    --background: 0 0% 100%; /* #ffffff */\n    --foreground: 0 0% 0%; /* #000000 */\n    --card: 0 0% 100%; /* #ffffff */\n    --card-foreground: 0 0% 0%; /* #000000 */\n    --popover: 0 0% 100%; /* #ffffff */\n    --popover-foreground: 0 0% 0%; /* #000000 */\n    --primary: 218 68% 37%; /* #1e4d9f */\n    --primary-foreground: 0 0% 100%; /* #ffffff */\n    --secondary: 336 77% 54%; /* #e4317a */\n    --secondary-foreground: 0 0% 100%; /* #ffffff */\n    --tertiary: 186 83% 37%; /* #109faf */\n    --tertiary-foreground: 0 0% 94%; /* #f0f0f0 */\n    --muted: 210 14% 83%; /* #4a5573 */\n    --muted-foreground: 221 13% 29%; /* #404653 */\n    --accent: 0 0% 85%; /* #393e4d */\n    --accent-foreground: 0 1% 30%; /* #b9c2d1 */\n    --destructive: 0 79% 63%; /* #eb5757 */\n    --destructive-foreground: 0 0% 100%; /* #ffffff */\n    --input: 0 0% 100%; /* #ffffff */\n    --input-foreground: 0 0% 0%; /* #000000 */\n    --ring: 218 68% 37%; /* #1e4d9f */\n    --success: 123 72% 31%; /* #278917 */\n    --success-foreground: 0 0% 100%; /* #ffffff */\n    --success-hover: 123 80% 30%; /* #0e8a1a */\n    --success-secondary: 163 100% 30%; /* #009966 */\n    --success-secondary-hover: 161 100% 27%; /* #008a5c */\n    --info: 211 100% 45%; /* #0073e6 */\n    --info-foreground: 0 0% 100%; /* #ffffff */\n    --label: 0 0% 23%; /* #3B3B3B */\n    --seldom: 0, 18, 64; /* #001240 */\n    --divider: 214 100% 18%; /* #00295e */\n\n    /* Background color */\n    --edit-resume-background: 210 80% 96%; /* #EDF5FD */\n    --search-bar: 204, 22%, 95%; /* #F1F4F6 */\n    --active-nav: 218, 80%, 23%; /*#0C2E6A*/\n    --project-nav: 228 81% 18%; /*091855*/\n\n    /* Primary colors palette */\n    --primary-50: 210 79% 89%; /* #CBE2F9 */\n    --primary-100: 206 73% 96%; /* #ECF5FC */\n    --primary-200: 226 73% 96%; /* #F1F4FD */\n    --primary-300: 199 100% 88%; /* #C1EAFF */\n    --primary-350: 205 60% 84%; /* #BFDBEF */\n    --primary-400: 198 73% 63%; /* #5CBDE6 */\n    --primary-450: 218 84% 88%; /*#C7DAFA*/\n    --primary-500: 198 73% 58%; /* #45B4E2 */\n    --primary-600: 198 73% 52%; /* #2BA9DE */\n    --primary-650: 219 77% 28%; /*#10367D*/\n    --primary-700: 201 100% 45%; /* #0095E4 */\n    --primary-750: 228 80% 21%; /* #0B1D62 */\n    --primary-800: 204 99% 36%; /* #016FB9 */\n    --primary-850: 202 93% 45%; /* #0890DD */\n    --primary-900: 214 100% 18%; /* #00295e */\n    --primary-950: 229 81% 18%; /* #091855 */\n\n    /* Secondary colors palette */\n    --secondary-100: 336 74% 47%; /* #d11f68 */\n\n    /* Frost colors palette */\n    --frost-50: 220 14% 96%; /* #f3f4f6 */\n    --frost-100: 200 18% 93%; /* #ebeff1 */\n    --frost-150: 200 17% 93%; /* #EAEEF0 */\n    --frost-200: 213 25% 95%; /* #edf2f8 */\n    --frost-250: 0 0% 85%; /* #d9d9d9 */\n    --frost-300: 225 5% 71%; /* #b3b5ba */\n    --frost-400: 0 0% 70%; /* #b2b2b2 */\n    --frost-500: 0 0% 67%; /* #ababab */\n    --frost-600: 0 0% 46%; /* #757575 */\n    --frost-650: 212 13% 61%; /* #8f98a8 */\n    --frost-700: 214 13% 41%; /* #5c6677 */\n    --frost-750: 213 15% 38%; /* #535d6f */\n    --frost-800: 213 16% 36%; /* #4d586b */\n    --frost-900: 221 13% 29%; /* #404653 */\n    --frost-950: 217 14% 25%; /* #374151 */\n\n    /* Border color palette */\n    --border-200: 240 36% 95%; /* #ECECF6 */\n    --border-250: 216 26% 91%; /* #e2e7ef */\n    --border-270: 211 20% 86%; /* #d2d8e3 */\n    --border-300: 200 18% 93%; /* #EBEFF1 */\n    --border-350: 220 18% 88%; /* #d9dde7 */\n    --border-400: 210 22% 84%; /* #cbd5e1 */\n    --border-450: 213 18% 85%; /* #cfd5e1 */\n    --border-500: 27 10% 82%; /* #d6d1cd */\n    --border-600: 0 0 85%; /* #d9d9d9 */\n\n    /* Label status background color */\n    --label-100: 48 100% 71%; /* #FFE16B */\n    --label-200: 357 95% 93%; /* #FEDBDD */\n    --label-300: 38 79% 81%; /* #F5D9A8 */\n    --label-350: 210 79% 89%; /* #CBE2F9 */\n    --label-400: 156 64% 90%; /* #D6F6E9 */\n    --label-450: 201 100% 80%; /* #99DCFF */\n    --label-500: 201 100% 64%; /* #46BFFF */\n    --label-550: 222 61% 53%; /*#3E69D0*/\n    --label-600: 0 0% 25%; /* #404040 */\n    --label-650: 35 100% 84%; /* #FFDDAD */\n    --label-700: 33 86% 46%; /* #DC8211 */\n\n    --label-completed: 149 100% 39%; /* #00C860 */\n    --label-archived: 307 25% 66%; /* #BE94B9 */\n    --label-archived-text: 300 61% 24%; /* #611761 */\n\n    /* Label status info color */\n    --info-100: 330 99% 37%; /* #BA015E */\n    --info-200: 26 100% 25%; /* #813800 */\n    --info-300: 48 71% 23%; /* #635211 */\n    --info-700: 204 78% 29%; /* #105584 */\n    --info-800: 152 100% 26%; /* #008747 */\n\n    /* Ocean color palette */\n    --ocean-50: 214 100% 98%; /* #f5f9ff */\n    --ocean-200: 200 33% 68%; /* #94B7C9 */\n    --ocean-500: 210 62% 44%; /* #2b74b6 */\n    --ocean-550: 210 62% 37%; /* #23649d */\n    --ocean-600: 205 72% 40%; /* #1D71AF */\n    --ocean-650: 210 34% 32%; /* #36506c */\n    --ocean-700: 208 98% 26%; /* #014783 */\n\n    /* Project palette colors */\n    --grass: 98 64% 46%; /* #61bf2a */\n    --tangerine: 33 85% 53%; /* #ed9121 */\n    --ocean: 201 100% 45%; /* #0095e4 */\n    --crimson: 336 77% 54%; /* #e4317a */\n    --chartreuse: 58 97% 36%; /* #b7b103 */\n    --midnight: 205 100% 28%; /* #00548f */\n    --amethyst: 265 58% 62%; /* #9466d6 */\n    --steel: 229 19% 59%; /* #838AAA */\n\n    /* Employee relationship role colors */\n    --golden: 43 98% 66%; /* #FDCD56 */\n    --mint: 160 50% 60%; /* #67CCAB */\n    --lavender: 248 29% 53%; /* #6C63A9 */\n    --coral: 5 71% 66%; /* #E6766B */\n    --slate-blue: 221 37% 49%; /* #4F6CAC */\n    --cornflower: 232 70% 66%; /* #6B7CE5 */\n  }\n  * {\n    @apply border-border;\n  }\n  html {\n    @apply scroll-smooth;\n    @apply scroll-pt-header-nav;\n  }\n\n  /*\n  * Override CopilotKit inline styles – must use !important\n  */\n  body {\n    @apply bg-background text-foreground !static !overflow-auto !h-auto;\n  }\n\n  /* Scroll lock override for data-scroll-locked attribute */\n  html body[data-scroll-locked] {\n    overflow: visible !important;\n    margin-right: 0 !important;\n  }\n\n  /* Styles for list bullet points */\n  li::marker {\n    @apply text-slate-800/80;\n  }\n\n  #employee-info {\n    li::marker {\n      @apply text-frost-900;\n    }\n\n    code {\n      @apply bg-frost-400;\n    }\n  }\n\n  [id='project-description'] li::marker {\n    @apply text-white;\n  }\n\n  [id='employee-training-content'] li {\n    @apply list-disc list-inside;\n  }\n}\n\n@layer utilities {\n  .flex-center {\n    @apply flex items-center justify-center;\n  }\n\n  .flex-start {\n    @apply flex items-center justify-start;\n  }\n\n  .centered-container {\n    @apply flex items-center flex-col py-14 px-6 lg:py-0 lg:h-screen;\n  }\n\n  .user-content-spacing {\n    @apply py-4 px-4 sm:px-8 sm:py-15.25 lg:py-6.5 lg:px-6.5;\n  }\n\n  .break-word {\n    word-break: break-word;\n  }\n\n  /* Custom leading */\n  .custom-leading p,\n  .custom-leading li,\n  .custom-leading li::marker,\n  .custom-leading ul,\n  .custom-leading ol,\n  .custom-leading span,\n  .custom-leading a,\n  .custom-leading div,\n  .custom-leading blockquote {\n    @apply text-white leading-2xs w-fit;\n  }\n\n  /* Custom scrollbar */\n  ::-webkit-scrollbar {\n    @apply w-3 h-3 bg-transparent;\n  }\n\n  ::-webkit-scrollbar:hover {\n    @apply w-3 h-3;\n    background-color: rgba(0, 0, 0, 0.06);\n  }\n\n  .tiny-scrollbar::-webkit-scrollbar {\n    @apply w-[5px] sm:w-1.5;\n  }\n\n  .tiny-scrollbar::-webkit-scrollbar:hover {\n    @apply w-[5px] sm:w-1.5;\n  }\n\n  .small-scrollbar::-webkit-scrollbar {\n    @apply w-2 h-2;\n  }\n\n  .small-scrollbar::-webkit-scrollbar:hover {\n    @apply w-2 h-2;\n  }\n\n  /* Overlay scrollbar - scrollbar does not take up space */\n  .overlay-scrollbar {\n    overflow-y: overlay; /* Works in Chromium browsers */\n  }\n\n  /* Fallback for browsers that don't support overlay */\n  @supports not (overflow-y: overlay) {\n    .overlay-scrollbar {\n      overflow-y: auto;\n      scrollbar-gutter: stable;\n    }\n  }\n\n  ::-webkit-scrollbar-thumb {\n    @apply rounded bg-black/25 min-h-10;\n  }\n\n  ::-webkit-scrollbar-thumb:active {\n    @apply bg-black/40;\n  }\n\n  /* Icon */\n  .fill-icon {\n    @apply fill-gray-700 dark:fill-gray-100;\n  }\n\n  .stroke-icon {\n    @apply stroke-gray-700 dark:stroke-gray-100;\n  }\n\n  .select-icon-button {\n    @apply size-4 flex-center transition-colors cursor-pointer;\n  }\n\n  .select-icon-button:disabled {\n    @apply cursor-not-allowed;\n  }\n\n  .clear-icon-button {\n    @apply size-full text-frost-500 hover:text-primary-500;\n  }\n\n  .select-icon-button:disabled .clear-icon-button {\n    @apply text-frost-300 hover:text-frost-300;\n  }\n\n  /* Override browser autocomplete background */\n  input:-webkit-autofill,\n  input:-webkit-autofill:hover,\n  input:-webkit-autofill:focus,\n  input:-webkit-autofill:active {\n    -webkit-text-fill-color: hsl(var(--slate-800)) !important;\n    transition: background-color 5000s ease-in-out 0s;\n  }\n\n  .dark input:-webkit-autofill,\n  .dark input:-webkit-autofill:hover,\n  .dark input:-webkit-autofill:focus,\n  .dark input:-webkit-autofill:active {\n    @apply bg-background;\n    -webkit-text-fill-color: white !important;\n    box-shadow: inset 0 0 20px 20px var(--background);\n    caret-color: white;\n  }\n\n  .aspect-a4 {\n    @apply aspect-[1/1.414];\n  }\n\n  /* Hide scrollbar for Chrome, Safari and Opera */\n  .no-scrollbar::-webkit-scrollbar {\n    display: none;\n  }\n\n  /* Hide scrollbar for IE, Edge and Firefox */\n  .no-scrollbar {\n    -ms-overflow-style: none; /* IE and Edge */\n    scrollbar-width: none; /* Firefox */\n  }\n}\n\n@layer components {\n  .cl-base-button {\n    @apply flex-center rounded-sm font-medium transition-colors;\n    @apply text-2xs md:text-xs xl:text-md;\n    @apply bg-primary text-primary-foreground hover:bg-destructive;\n    @apply [&_svg]:pointer-events-none [&_svg]:shrink-0;\n    @apply focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring;\n    @apply disabled:pointer-events-none disabled:opacity-50;\n    @apply data-[variant=solid]:data-[color=primary]:shadow-none;\n  }\n\n  .cl-base-text {\n    @apply text-3xs xl:text-xs;\n  }\n\n  .cl-base-form {\n    @apply w-full max-w-form h-full mx-auto overflow-hidden;\n\n    .cl-cardBox {\n      @apply w-full shadow-none border-none overflow-visible;\n    }\n\n    .cl-card {\n      @apply w-full p-0 rounded-none shadow-none dark:bg-background;\n    }\n\n    .cl-form {\n      @apply order-1 dark:bg-background;\n    }\n\n    .cl-dividerRow {\n      @apply order-2 hidden;\n    }\n\n    .cl-socialButtonsRoot {\n      @apply order-3 hidden;\n    }\n\n    .cl-footer {\n      @apply hidden;\n    }\n\n    .cl-headerTitle {\n      @apply text-2xl md:text-3xl xl:text-[28px] dark:text-foreground font-normal;\n    }\n\n    .cl-headerSubtitle,\n    .cl-identityPreviewText {\n      @apply text-3xs text-slate-500 font-normal;\n      @apply dark:text-white/70;\n    }\n\n    .cl-formButtonPrimary,\n    .cl-alternativeMethodsBlockButton {\n      @apply cl-base-button;\n    }\n\n    .cl-formResendCodeLink {\n      @apply cl-base-text font-normal text-info disabled:opacity-55 dark:disabled:opacity-65;\n    }\n\n    .cl-identityPreviewEditButton {\n      @apply hidden;\n    }\n\n    .cl-otpCodeField {\n      .cl-otpCodeFieldInput {\n        @apply size-10 sm:size-14 md:size-[70px] max-h-none;\n        @apply text-3xs md:text-xs dark:text-foreground ring-1 ring-slate-200 rounded-md;\n        @apply dark:hover:ring-1 dark:hover:ring-white dark:focus:ring-1 dark:focus:ring-white dark:active:ring-1 dark:active:ring-white;\n        @apply focus:shadow-none focus:ring-slate-800 focus:bg-white dark:focus:bg-background;\n\n        /* Focus styles */\n        @apply data-[feedback=error]:focus-within:shadow-none;\n        @apply data-[feedback=error]:focus-within:ring-destructive;\n        @apply data-[feedback=success]:focus-within:shadow-none;\n        @apply data-[feedback=success]:focus-within:ring-success;\n\n        /* Hover styles */\n        @apply data-[feedback=error]:hover:shadow-none;\n        @apply data-[feedback=error]:hover:ring-destructive;\n        @apply data-[feedback=success]:hover:shadow-none;\n        @apply data-[feedback=success]:hover:ring-success;\n\n        /* Active styles */\n        @apply data-[feedback=error]:active:shadow-none;\n        @apply data-[feedback=error]:active:ring-destructive;\n        @apply data-[feedback=success]:active:shadow-none;\n        @apply data-[feedback=success]:active:ring-success;\n      }\n\n      .cl-otpCodeFieldErrorText {\n        @apply [&_svg]:text-destructive cl-base-text text-destructive;\n      }\n    }\n\n    .cl-alert {\n      @apply [&_svg]:text-destructive;\n\n      .cl-alertText {\n        @apply text-destructive;\n      }\n    }\n\n    .cl-formFieldLabel {\n      @apply dark:text-foreground;\n    }\n\n    .cl-formFieldInput {\n      @apply ring-1 ring-border hover:ring-slate-300 focus:ring-slate-300 active:ring-slate-300;\n      @apply dark:bg-background dark:focus:bg-background dark:text-foreground;\n      @apply dark:ring-white/50 dark:ring-1 dark:placeholder:text-white/55;\n      @apply dark:hover:ring-1 dark:hover:ring-white dark:focus:ring-1 dark:focus:ring-white dark:active:ring-1 dark:active:ring-white;\n      @apply data-[feedback=success]:shadow-none data-[feedback=success]:ring-success/50;\n      @apply data-[feedback=error]:shadow-none data-[feedback=error]:ring-destructive/50;\n\n      /* Focus styles */\n      @apply data-[feedback=error]:focus-within:shadow-none;\n      @apply data-[feedback=error]:focus-within:ring-destructive;\n      @apply data-[feedback=success]:focus-within:shadow-none;\n      @apply data-[feedback=success]:focus-within:ring-success;\n\n      /* Hover styles */\n      @apply data-[feedback=error]:hover:shadow-none;\n      @apply data-[feedback=error]:hover:ring-destructive;\n      @apply data-[feedback=success]:hover:shadow-none;\n      @apply data-[feedback=success]:hover:ring-success;\n\n      /* Active styles */\n      @apply data-[feedback=error]:active:shadow-none;\n      @apply data-[feedback=error]:active:ring-destructive;\n      @apply data-[feedback=success]:active:shadow-none;\n      @apply data-[feedback=success]:active:ring-success;\n    }\n\n    .cl-formFieldInputShowPasswordButton {\n      @apply fill-gray-700 dark:fill-gray-100 dark:stroke-gray-100 group-hover:dark:fill-gray-700 group-hover:dark:stroke-slate-800;\n    }\n  }\n\n  /* Forgot password */\n  .cl-base-form .cl-card.cl-signIn-forgotPasswordMethods {\n    @apply gap-14;\n\n    .cl-formResendCodeLink {\n      @apply bg-transparent hover:bg-transparent text-xs mt-13.75;\n    }\n\n    .cl-alternativeMethodsBlockButton {\n      @apply py-3.75;\n    }\n\n    .cl-backLink {\n      @apply hidden;\n    }\n  }\n\n  .cl-base-form:has(\n    .cl-headerTitle[data-localization-key='signIn.forgotPasswordAlternativeMethods.title']\n  ) {\n    @apply h-full flex-center;\n  }\n\n  /* Reset new password */\n  .cl-base-form.cl-signIn-root .cl-cardBox.cl-signIn-resetPassword {\n    @apply h-full flex-center;\n  }\n\n  .cl-base-form.cl-signIn-root .cl-card.cl-signIn-resetPassword {\n    @apply gap-12;\n\n    .cl-form {\n      @apply -order-none gap-0;\n    }\n\n    .cl-headerSubtitle {\n      @apply mt-3;\n    }\n\n    .cl-formResendCodeLink {\n      @apply mt-13.75 text-xs;\n    }\n\n    .cl-formButtonPrimary {\n      @apply py-3.75;\n    }\n\n    .cl-buttonArrowIcon {\n      @apply hidden;\n    }\n  }\n\n  /* Set new password form */\n  .cl-base-form.cl-signIn-root {\n    &:has(h1[data-localization-key='signIn.resetPassword.title']) {\n      @apply flex-center;\n    }\n\n    &:not(\n        :has(label[data-localization-key='formFieldLabel__emailAddress'])\n      ):has(label[data-localization-key='formFieldLabel__password']) {\n      @apply lg:pt-36;\n    }\n\n    .cl-card {\n      @apply gap-14 lg:gap-24;\n    }\n\n    .cl-formFieldRow__signOutOfOtherSessions {\n      @apply hidden;\n    }\n\n    .cl-footerAction__alternativeMethods {\n      @apply hidden;\n    }\n  }\n\n  /* SignUp */\n  .cl-base-form {\n    .cl-signUp-start .cl-header {\n      @apply hidden;\n    }\n\n    .cl-formFieldLabel {\n      @apply cl-base-text font-normal text-label mb-1;\n    }\n\n    .cl-formFieldInput {\n      @apply cl-base-text;\n      @apply min-h-14 rounded-md;\n      @apply focus:shadow-none focus:ring-slate-800 focus:bg-white;\n      @apply placeholder:text-slate-500 placeholder:opacity-50;\n    }\n\n    .cl-formFieldInfoText {\n      @apply text-slate-500;\n    }\n\n    .cl-formFieldErrorText {\n      @apply mt-3 text-destructive [&_svg]:text-destructive;\n    }\n\n    .cl-formFieldSuccessText {\n      @apply cl-base-text text-success [&_svg]:text-success;\n    }\n\n    .cl-form {\n      @apply gap-12;\n    }\n\n    .cl-formFieldInputShowPasswordButton {\n      @apply shadow-none h-full bg-transparent;\n\n      .cl-formFieldInputShowPasswordIcon {\n        @apply w-6 h-6;\n      }\n    }\n\n    .cl-formButtonPrimary {\n      @apply rounded-md py-[14px] [&_svg]:hidden;\n    }\n  }\n\n  /* Verify email */\n  .cl-base-form .cl-signUp-emailCode {\n    @apply gap-8 h-full;\n\n    .cl-card {\n      @apply flex-center h-full;\n    }\n\n    .cl-headerTitle {\n      @apply mb-3;\n    }\n\n    .cl-main {\n      @apply gap-7 mt-4;\n    }\n\n    .cl-form {\n      @apply order-none gap-11;\n    }\n  }\n\n  /* LogIn */\n  .cl-base-form {\n    .cl-signIn-start {\n      .cl-card {\n        @apply gap-12;\n      }\n\n      .cl-header {\n        @apply hidden;\n      }\n\n      .cl-form {\n        @apply gap-14 lg:gap-[65px];\n      }\n    }\n\n    .cl-signIn-password {\n      .cl-header {\n        @apply hidden;\n      }\n\n      .cl-card {\n        @apply gap-12;\n      }\n\n      .cl-form {\n        @apply gap-14 lg:gap-[65px];\n      }\n    }\n\n    .cl-formFieldLabelRow {\n      @apply contents;\n    }\n\n    .cl-formFieldAction {\n      @apply absolute right-0 bottom-[-30px];\n      @apply cl-base-text font-normal text-info;\n    }\n\n    .cl-formFieldInputGroup {\n      @apply order-none;\n    }\n\n    .cl-formField {\n      @apply relative px-1;\n    }\n\n    .cl-formFieldErrorText {\n      @apply cl-base-text text-destructive;\n    }\n\n    .cl-signIn-emailCode {\n      .cl-card {\n        @apply gap-12;\n      }\n\n      .cl-main {\n        @apply gap-7;\n      }\n\n      .cl-form {\n        @apply order-none gap-11;\n      }\n    }\n  }\n}\n\n.text-shadow-md {\n  text-shadow:\n    0px 1px 1px rgb(0 0 0 / 0.1),\n    0px 1px 2px rgb(0 0 0 / 0.1),\n    0px 2px 4px rgb(0 0 0 / 0.1);\n}\n\n.react-pdf__message--loading,\n.react-pdf__Document {\n  height: 100%;\n}\n\n.react-pdf__Page {\n  height: 100%;\n}\n\n.scale-up-center {\n  -webkit-animation: scale-up-center 0.2s cubic-bezier(0.39, 0.575, 0.565, 1)\n    both;\n  animation: scale-up-center 0.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;\n}\n\n@keyframes flash-error {\n  0%,\n  100% {\n    background-color: hsl(var(--destructive));\n    color: hsl(var(--destructive-foreground));\n  }\n  50% {\n    background-color: transparent;\n    color: hsl(var(--slate-800));\n  }\n}\n\n.animate-flash-error {\n  animation: flash-error;\n}\n\n@-webkit-keyframes scale-up-center {\n  0% {\n    -webkit-transform: scale(0.5);\n    transform: scale(0.5);\n  }\n  100% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n@keyframes scale-up-center {\n  0% {\n    -webkit-transform: scale(0.5);\n    transform: scale(0.5);\n  }\n  100% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
